import { Box, Button } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import HtmlText from 'presentation/components/shared/HtmlText/HtmlText';
import downloadFile from 'presentation/utils/downloadFile';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  report: PeCompanyReport;
}

const PeCompanyReportSection: FC<Props> = ({ report }) => {
  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{t('peCompanyReport')}</GridHeading>
      <AppCard p="20px">
        {report.description && (
          <Box mb="20px">
            <HtmlText text={report.description} />
          </Box>
        )}
        <Button
          onClick={() => {
            if (report.fileUrl) {
              downloadFile(report.fileUrl);
            }
          }}
        >
          {t('downloadReport')}
        </Button>
      </AppCard>
    </>
  );
};

export default PeCompanyReportSection;
